import React from "react"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { thousandSeparator } from "utils"
import classes from "./ApprovePaymentModalHeader.module.scss"

const ApprovePaymentModalKeypad = (props) => {
  const { totalSelectedOrders } = props

  const [t, i18n] = useTranslation()

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={classes["payableContainer"]}>
      <div className={classes["title"]}>
        {t("پرداختی")}
      </div>
      <div
        className={clsx(
          classes["payable"],
          isLtr && classes["payable-ltr"]
        )}
      >
        {t("قابل پرداخت")}{" "}
        <span className={classes["total"]}>
          {thousandSeparator(totalSelectedOrders)}
        </span>
      </div>
    </div>
  )
}

export default ApprovePaymentModalKeypad